import { render } from "./ManagerSalesPositionsTable.vue?vue&type=template&id=3f1af45b&scoped=true"
import script from "./ManagerSalesPositionsTable.vue?vue&type=script&lang=js"
export * from "./ManagerSalesPositionsTable.vue?vue&type=script&lang=js"

import "./ManagerSalesPositionsTable.vue?vue&type=style&index=0&id=3f1af45b&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1af45b"]])

export default __exports__